/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerheadlinecount3Inputs */

const en_checkinflyerheadlinecount3 = /** @type {(inputs: Checkinflyerheadlinecount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check in to the Live Room`)
};

const de_checkinflyerheadlinecount3 = /** @type {(inputs: Checkinflyerheadlinecount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check ein im Live Room`)
};

/**
* | output |
* | --- |
* | "Check in to the Live Room" |
*
* @param {Checkinflyerheadlinecount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerheadlinecount3 = /** @type {((inputs?: Checkinflyerheadlinecount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerheadlinecount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerheadlinecount3(inputs)
	return de_checkinflyerheadlinecount3(inputs)
});
export { checkinflyerheadlinecount3 as "checkinFlyerHeadlineCount" }